<template>
    <div class="flex flex-wrap items-center flex-col justify-end md:justify-center pb-16 md:pb-0">
        <h5 class="text-lg text-center text-yellow-200 bg-gray-950 rounded-t-lg p-3">
            <span class="text-white text-base leading-snug">
                {{ question.attributes.choices.top }}
            </span><br>
            {{ question.attributes.choices.note }}
<!--            @todo  apply to both above, textPersonlize() and replace the 10 with the circle->parent->id-->
        </h5>

        <!-- This is if it's a choose_one Display Type -->
        <!-- <ul v-if="question.attributes.choices.display_type == 'choose_one'">
            <li v-for="(choice, index) in question.attributes.choices.options">
                <input type="hidden" name="saveChooseOne" :value="choice.save">

                <button type="button"
                    @click="answer(choice.save)"
                    class="px-5 py-2"
                >
                    <i aria-hidden="true" class="material-icons align-middle">check</i> {{ choice.display }}
                </button>
            </li>
        </ul> -->

        <!-- This is if it's a choose_one_pole Display Type -->
        <div v-if="question.attributes.choices.display_type == 'scale'" class="w-full md:w-2/3">
            <div class="flex flex-col">
                <vue-slider
                    class="feedback-slider"
                    height="5rem"
                    dotSize="2.5rem"
                    v-model="value"
                    :min="1"
                    :max="1000"
                    :tooltip="'none'"
                    @change="sliderChanged"
                >

                    <template v-slot:dot="{ value, focus }">
                        <div :class="['custom-dot', { focus }]"></div>
                    </template>

                </vue-slider>
                <div class="feedback-labels">
                    <div class="section font-black">
                        <strong>{{ question.attributes.choices.options[1].display }}</strong>
                    </div>
                    <div class="section hide font-normal">
                        <strong>{{ question.attributes.choices.options[2].display }}</strong>
                    </div>
                    <div class="section font-light">
                        <strong>{{ question.attributes.choices.options[3].display }}</strong>
                    </div>
                    <div class="section hide font-normal">
                        <strong>{{ question.attributes.choices.options[4].display }}</strong>
                    </div>
                    <div class="section font-black">
                        <strong>{{ question.attributes.choices.options[5].display }}</strong>
                    </div>
                </div>

                <div class="submit-button-wrapper mt-5">
                    <div v-if="demo !== ('1')">
                        <button @click="answer(value)"
                            type="submit"
                            class="submitResults px-5 py-2"
                            :class="canSave ? 'cursor-pointer' : 'opacity-0'"
                        >
                            {{ $t('Continue') }} <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i>
                        </button>
                    </div>
                    <div v-else>
                      <button @click="restartActivity" type="submit" class="submitResults px-5 py-2">{{ $t('Restart Demo') }}<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import VTooltip from 'v-tooltip';
import VueSlider from 'vue-slider-component'

export default {
    components: {
      VueSlider
    },

    props: {
        question: {},
    },

    methods: {
        answer(value) {
            this.$emit('answered', String(Math.round(value/10)));
        },
        sliderChanged () {
            this.canSave = true;
        },
    },

    data() {
      return {
        canSave: false,
        value: 500,
      }
    }
};
</script>
